import React from 'react';

this.hover = e => {
  e.target.setAttribute(
    'src',
    'https://image.flaticon.com/icons/svg/34/34196.svg'
  );
};

this.unhover = e => {
  e.target.setAttribute(
    'src',
    'https://image.flaticon.com/icons/svg/263/263093.svg'
  );
};

const Directors = ({ directors }) =>
  directors.map(e => (
    <div className="page_contacts" key={e.id}>
      <img
        src={e.img || 'https://res.cloudinary.com/dwvrok1le/image/upload/v1654014904/2207595.png'}
        alt="Director img"
      />
      <div>
        <h4>{e.name}</h4>
        <a href={'mailto:' + e.email}>
          <img
            src="https://svgsilh.com/svg_v2/147563.svg"
            // src="https://res-console.cloudinary.com/dwvrok1le/thumbnails/v1/image/upload/v1654014945/MTQ3NTYz/preview"
            alt={e.email}
            className="email_icon"
            // onMouseOver={this.hover}
            // onMouseOut={this.unhover}
          />
        </a>
      </div>
      <p>{e.position}</p>
    </div>
  ));

export default Directors;



// WEBPACK FOOTER //
// ./src/Components/Tools/Directors.js